import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=021d4686&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=021d4686&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d4686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021d4686')) {
      api.createRecord('021d4686', component.options)
    } else {
      api.reload('021d4686', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=021d4686&scoped=true&", function () {
      api.rerender('021d4686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/Header/Button.vue"
export default component.exports